import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { initialState } from './reducer';
import { State, GestorTabla, FormadorTabla, AlumnoTabla } from './types';
import { RequestStatus } from 'types';

const selectState = (state: RootState) => state.cursos || initialState;

const parseProvincias = (provincias) => {
  const provin = provincias.map((provincia) => ({
    label: provincia,
    value: provincia,
    active: 'false',
  }));

  return JSON.stringify(provin);
};

const parseSociedades = (sociedades) => {
  const socied = sociedades.map((sociedad) => ({
    label: sociedad.ID_SOCIEDAD + ' - ' + sociedad.NOMBRE_SOCIEDAD,
    value: sociedad.ID_SOCIEDAD,
    active: 'false',
    item: sociedad,
  }));

  return JSON.stringify(socied);
};

// Alumnos
export const makeSelectAlumnosCursos = () =>
  createSelector(selectState, (state: State): any[] => state.alumnosCursos);

export const makeSelectAlumnosCursosCount = () =>
  createSelector(
    selectState,
    (state: State): number => state.alumnosCursosCount
  );

export const makeSelectAlumnosCurso = () =>
  createSelector(selectState, (state: State): any => state.curso);

// Cursos
export const makeSelectCursos = () =>
  createSelector(selectState, (state: State): any[] => state.cursos);

export const makeSelectCursosCount = () =>
  createSelector(selectState, (state: State): number => state.cursosCount);

export const makeSelectSociedadesCursosParsed = () =>
  createSelector(selectState, (state: State): string =>
    parseSociedades(state.sociedades)
  );

export const makeSelectProvinciasCursosParsed = () =>
  createSelector(selectState, (state: State): string =>
    parseProvincias(state.provincias)
  );

export const makeSelectEstadosCursosParsed = () =>
  createSelector(selectState, (state: State): string => {
    const estados = state.estados.map((estado) => ({
      label: estado.DESC_ESTADO,
      value: estado.ID_ESTADO,
      active: 'false',
    }));

    return JSON.stringify(estados);
  });

export const makeSelectCursosFilterParsed = () =>
  createSelector(selectState, (state: State): string => {
    const cursosFilter = state.cursosFilter.map((curso) => ({
      label: curso.ID_CURSO + ' - ' + curso.NOMBRE_CURSO,
      value: curso.ID_CURSO,
      active: 'false',
    }));

    return JSON.stringify(cursosFilter);
  });

// Cursos cierre
export const makeSelectCursosCierre = () =>
  createSelector(selectState, (state: State): any[] => state.cursosCierre);

export const makeSelectCursosCierreCount = () =>
  createSelector(
    selectState,
    (state: State): number => state.cursosCierreCount
  );

export const makeSelectProvinciasCursosCierreParsed = () =>
  createSelector(selectState, (state: State): string =>
    parseProvincias(state.provinciasCursosCierre)
  );

export const makeSelectSociedadesCursosCierreParsed = () =>
  createSelector(selectState, (state: State): string =>
    parseSociedades(state.sociedadesCursosCierres)
  );

// Caché
export const makeSelectAllSociedades = () =>
  createSelector(selectState, (state: State): any[] => state.allSociedades);


 //panel administracion
 //gestores
  export const makeSelectAllGestores = () =>
  createSelector(
    [selectState],
    (state: State): GestorTabla[] => state.gestoresAll
  );

  export const makeSelectGetAllGestoresRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.getAllGestoresRequestStatus
  );

  export const makeSelectInsertarGestoresCursosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.insertarGestoresCursosRequestStatus
  );

  export const makeSelectEliminarGestoresCursosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.eliminarGestoresCursosRequestStatus
  );


  //formadores
    export const makeSelectAllFormadores = () =>
  createSelector(
    [selectState],
    (state: State): FormadorTabla[] => state.formadoresAll
  );

  export const makeSelectGetAllFormadoresRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.getAllFormadoresRequestStatus
  );
  export const makeSelectInsertarFormadoresCursosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.insertarFormadoresCursosRequestStatus
  );

  export const makeSelectEliminarFormadoresCursosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.eliminarFormadoresCursosRequestStatus
  );

  //alumnos
  export const makeSelectAllAlumnos = () =>
  createSelector(
    [selectState],
    (state: State): AlumnoTabla[] => state.alumnosAll
  );

  export const makeSelectGetAllAlumnosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.getAllAlumnosRequestStatus
  );

  export const makeSelectInsertarAlumnosCursosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.insertarAlumnosCursosRequestStatus
  );

  export const makeSelectEliminarAlumnosCursosRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.eliminarAlumnosCursosRequestStatus
  );
